
import { Request } from "../Servidor/Request";

export async function hasPermission(requiredPermissions: string[]): Promise<{}> {
    if (!requiredPermissions || requiredPermissions.length === 0) {
        return false;
    }

    try {
        const rs = await new Request().requestPost("permissoes/checar", { permissoes: requiredPermissions });
        if (rs.permissions) {
            return rs.permissions
        }

        return {};

    } catch (err) {
        console.error("Erro ao checar permissões:", err);
        return {};
    }
}
